/**
 * Product flag key strings used by the nav gates.
 * Flags are created in Admin (or seed). `isEnabled` is true only when the eval says true, so a missing key is off.
 */
export const FEATURE_FLAG_KEYS = {
  tearsheets: 'tearsheets',
  tearsheetsIsSubscriber: 'tearsheets/is_subscriber',
  oms: 'oms',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[keyof typeof FEATURE_FLAG_KEYS];
